import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// Components
import QuestionsArea from './QuestionsArea';

// Actions
import { setParticipantComments } from 'store/reducers/appointment/actions';

// Selectors
import { getAppointment } from 'store/reducers/appointment/selectors';

const mapStateToProps = state => ({ appointment: getAppointment(state) });

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    { setParticipantComments }
  )
)(QuestionsArea);



// WEBPACK FOOTER //
// ./src/components/atoms/QuestionsArea/QuestionsAreaContainer.js